import { generateCharacterSpeechMutationRequest } from '../../requests/generate-character-speech.mutation.ts';
import { GenerateCharacterSpeechInput } from '../../types/generate-character-speech.types.ts';

import { BaseSpeechUtil } from './base-speech.util.ts';

export class GenerateSpeechUtil extends BaseSpeechUtil<GenerateCharacterSpeechInput> {
  private static _instance: GenerateSpeechUtil;

  public static get instance(): GenerateSpeechUtil {
    if (!GenerateSpeechUtil._instance) {
      GenerateSpeechUtil._instance = new GenerateSpeechUtil();
    }
    return GenerateSpeechUtil._instance;
  }

  protected override async onConnected(params: GenerateCharacterSpeechInput): Promise<void> {
    await generateCharacterSpeechMutationRequest({
      ...params,
      promptOptions: {
        ...params.promptOptions,
        metadata: JSON.stringify(params.promptOptions.metadata),
      },
    });
  }
}

export const getGenerateSpeechUtil = (): GenerateSpeechUtil => GenerateSpeechUtil.instance;
